import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCallbackComponent } from 'auth-callback/auth-callback.component';
import { AuthCallbackModule } from 'auth-callback/auth-callback.module';
import { dialogRoutes } from 'dialog-routing';
import { AuthService } from 'providers/auth.service';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'search' },
    {
        path: 'auth-callback',
        pathMatch: 'full',
        component: AuthCallbackComponent,
        data: {
            hideLayout: true,
        },
    },
    {
        path: 'locations',
        loadChildren: () => import('./locations/locations.module').then((m) => m.LocationsModule),
    },
    {
        path: 'release-notes',
        loadChildren: () => import('./release-notes/release-notes.module').then((m) => m.ReleaseNotesModule),
    },
    {
        path: 'search',
        loadChildren: () => import('./search-page/search-page.module').then((m) => m.SearchPageModule),
        canActivate: [AuthService],
    },
    {
        path: 'vehicles',
        // TODO licensing
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['ev.allowTracking'],
        },
        loadChildren: () => import('./vehicles/vehicles.module').then((m) => m.VehiclesModule),
    },
    {
        path: 'fleet',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.usage.access'],
        },
        loadChildren: () => import('./fleet/fleet.module').then((m) => m.FleetModule),
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/tenant-settings.module').then((m) => m.TenantSettingsModule),
    },
    {
        path: 'reporting',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['fleet.chargingStation.usage.access'],
        },
        loadChildren: () => import('./reporting/reporting.module').then((m) => m.ReportingModule),
    },
    {
        path: 'power-groups',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['loadBalancing.access'],
        },
        loadChildren: () => import('./power-groups/power-groups.module').then((m) => m.PowerGroupsModule),
    },
    {
        path: 'health',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () =>
            import('./system-health-dashboard/system-health-dashboard.module').then(
                (m) => m.SystemHealthDashboardModule
            ),
    },
    {
        path: 'audit-logs',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
        },
        loadChildren: () => import('./audit-logs/audit-logs.module').then((m) => m.AuditLogsModule),
    },
    {
        path: 'admin/iam',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin', 'orgAdmin'],
            accessCondition: 'OR',
            pageId: 'iam',
        },
        loadChildren: () => import('./iam/iam.module').then((m) => m.IamModule),
    },
    {
        path: 'admin/svc',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
            accessCondition: 'OR',
            pageId: 'vc',
        },
        loadChildren: () => import('./services/svc.module').then((m) => m.SvcModule),
    },
    {
        path: 'admin/ev-identify-verifier',
        canActivate: [AuthService],
        data: {
            requiredPermissions: ['sysadmin'],
            pageId: 'ev-identify-verifier',
        },
        loadChildren: () =>
            import('./vehicles/ev-identify-verifier/ev-identify-verifier.module').then(
                (m) => m.EvIdentifyVerifierModule
            ),
    },
    ...dialogRoutes.map((d) => ({ ...d, outlet: 'd' })),
    ...dialogRoutes.map((d) => ({ ...d, outlet: 'd2' })),
    // 404 Redirection
    { path: '**', pathMatch: 'full', redirectTo: 'search' },
];

@NgModule({
    imports: [AuthCallbackModule, RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
